import { render, staticRenderFns } from "./biddingView.vue?vue&type=template&id=7aaa13f6&"
import script from "./biddingView.vue?vue&type=script&lang=js&"
export * from "./biddingView.vue?vue&type=script&lang=js&"
import style0 from "./biddingView.vue?vue&type=style&index=0&id=7aaa13f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports